import { Box, Modal, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./testpersoninfo.scss";
import closeicon from "../../../assets/images/closeIcon.svg";
import editIcon from "../../../assets/images/edit.svg";
import { getTestPersonInfo } from "../../../services/websiteApi";
import { ReportVerification, SymptomsStatus } from "../../../utlis/enums";
import { useDispatch } from "react-redux";
import { setAPILoader } from "../../../state/actions/globalAction";
import { Link } from "react-router-dom";
import { handleParams, isProd } from "../../../utlis/helpers";
import { userInfoFetch } from "../../../utlis/commonFunction";
import EmailChange from "../../modals/EmailChange";
import { pageLocale } from "../../../utlis/locale";

const TestPersonInfo = ({ openTestPerson, setOpenTestPerson }) => {
  const [testPersonData, setTestPersondata] = useState([]);
  const dispatch = useDispatch();
  const [emailPopUp, setEmailPopup] = useState({ state: false, data: "" });
  const {
    edit_info,
    id,
    test_score,
    na,
    zipcode,
    exercise,
    sends_reports,
    symptoms,
    injury_surgery,
  } = pageLocale("testPerson");
  useEffect(() => {
    dispatch(setAPILoader(true));
    getTestPersonInfo(userInfoFetch()?.id)
      .then((res) => {
        setTestPersondata(res?.data?.data);
        dispatch(setAPILoader(false));
      })
      .catch(() => {
        dispatch(setAPILoader(false));
      });
  }, []);
  const mainItems = (key) => {
    return testPersonData?.find((h) => h?.uniqueId === key)?.value;
  };
  const listItems = (key) => {
    return testPersonData?.find((h) => h?.uniqueId === key)?.items;
  };

  const PersonInfoWrap = ({ title, value, className }) => {
    return (
      <div className={className}>
        <Typography className="test-person-info-header">{title}</Typography>
        <Typography className="description">{value}</Typography>
      </div>
    );
  };
  //This is clearing the session and calling the api again. Bcz, we don't control of add and edit test person page. If the user updates something. It should reflect in user-list page we are doing this mechanism
  const editTestPersonHandler = () => {
    setOpenTestPerson(false); //to resolveundefined senioruuid ;
    sessionStorage.clear("userList");
  };
  return (
    <>
      <Modal
        open={openTestPerson}
        onClose={() => setOpenTestPerson(false)}
        className="test-person-info-modal--wrapper"
      >
        <Box className="test-person-info-block">
          <div className="close-test-person-info-wrap">
            <img
              src={closeicon}
              alt="close"
              className="close-icon"
              onClick={() => setOpenTestPerson(false)}
            />
          </div>
          <div className="test-person-header-wrap">
            <div className="test-person-title-wrap">
              <img
                src={userInfoFetch()?.picture}
                className="user-icon"
                alt="user"
              />
              <div className="test-person-info">
                <Typography className="name">
                  {userInfoFetch()?.name}
                </Typography>
                <div className="age-gender-wrap">
                  <Typography className="age-gender-info">
                    {userInfoFetch()?.gender}
                  </Typography>
                  <div className="straight-line"></div>
                  <Typography>{userInfoFetch()?.age}</Typography>
                </div>
              </div>
            </div>
            <Link
              to={`${isProd ? `https://testpersons.seniorlife.io` : `https://testpersons.dev.seniorlife.io`}/edit-test-person${handleParams()}&seniorUuid=${userInfoFetch()?.id}&showHeader=true&gobackWebsite=true`}
              // to={`${isProd ? `https://testpersons.seniorlife.io` : `https://testpersons.dev.seniorlife.io`}/edit-test-person/?seniorUuid=${userInfoFetch()?.id}&staffId=${storedTest?.id}&showHeader=true&locale=${locale}&accessToken=${accessToken}&gobackWebsite=true`}
              className="test-person-edit-wrap"
            >
              <div className="edit-block" onClick={editTestPersonHandler}>
                <img src={editIcon} alt="edit" />
                <Typography className="edit">{edit_info}</Typography>
              </div>
            </Link>
          </div>
          <div className="test-person-info-show-block">
            <PersonInfoWrap
              title={id}
              value={mainItems("seniorlife_id")}
              className="info-wrapper"
            />
            <div className="recent-test-score-wrap">
              <Typography className="test-person-info-header">
                {test_score}
              </Typography>
              <div className="test-score-wrapper">
                {listItems("score_widget")?.length > 0 ? (
                  listItems("score_widget")?.map((item, index) => {
                    return (
                      <div className="score-wrap" key={index}>
                        <Typography className="score">{item.value}</Typography>
                        <hr className="test-score-divider" />
                        <Typography className="score-name">
                          {item.name}
                        </Typography>
                      </div>
                    );
                  })
                ) : (
                  <div>{na}</div>
                )}
              </div>
            </div>
            <PersonInfoWrap
              title={zipcode}
              value={
                mainItems("zip_code")?.length > 0 ? mainItems("zip_code") : "NA"
              }
              className="info-wrapper"
            />
            <PersonInfoWrap
              title={exercise}
              value={
                mainItems("fitness_level")?.length > 0
                  ? mainItems("fitness_level")
                  : "NA"
              }
              className="info-wrapper"
            />
            <div className="send-reports-wrapper">
              <Typography className="test-person-info-header">
                {sends_reports}
              </Typography>
              {listItems("report_share_widget")?.length > 0 ? (
                listItems("report_share_widget")?.map((item, index) => {
                  return (
                    <>
                      <div className="item" key={index}>
                        <div className="info-block">
                          <Typography className="name">{item.name}</Typography>
                          <Typography
                            className="status"
                            style={{
                              color:
                                ReportVerification[item.verifiedStatus].color,
                            }}
                          >
                            {ReportVerification[item.verifiedStatus].text}
                          </Typography>
                        </div>
                        <div className="info-block" key={index}>
                          <Typography className="email">
                            {item.value}
                          </Typography>
                          <img
                            src={editIcon}
                            alt="edit"
                            onClick={() =>
                              setEmailPopup({ state: true, data: item })
                            }
                          />
                        </div>
                      </div>
                      <div className="dashed-line"></div>
                    </>
                  );
                })
              ) : (
                <div>{na}</div>
              )}
            </div>
            <div className="symptoms-wrapper">
              <Typography className="test-person-info-header">
                {symptoms}
              </Typography>
              <div className="symptoms-list-wrap">
                {listItems("symptoms")?.length > 0 ? (
                  listItems("symptoms")?.map((item, index) => {
                    return (
                      <div className="item" key={index}>
                        <Typography className="health-problem">
                          {item.name}
                        </Typography>
                        <Typography
                          className="status"
                          style={{
                            backgroundColor: SymptomsStatus[item.value].color,
                          }}
                        >
                          {SymptomsStatus[item.value].text}
                        </Typography>
                      </div>
                    );
                  })
                ) : (
                  <div>{na}</div>
                )}
              </div>
            </div>
            <div className="injury-surgery-wrap">
              <Typography className="test-person-info-header">
                {injury_surgery}
              </Typography>
              <div className="injury-list-wrap">
                {listItems("injury_and_surgery")?.length > 0 ? (
                  listItems("injury_and_surgery")?.map((item, index) => {
                    return (
                      <Typography className="item" key={index}>
                        {item.name}
                      </Typography>
                    );
                  })
                ) : (
                  <div>{na}</div>
                )}
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      {emailPopUp?.state && (
        <EmailChange emailPopUp={emailPopUp} setEmailPopup={setEmailPopup} />
      )}
    </>
  );
};

export default TestPersonInfo;
